<template>
  <v-container fill-height fluid class="pa-0 justify-center overflow-auto">
    <v-card
      v-if="adminValid < 2"
      class="text-center"
      flat
      color="transparent"
      width="320px"
    >
      <v-img
        class="mx-auto"
        width="100px"
        :src="require('@/assets/branding/Signature(ko)_Light.svg')"
      />
      <v-card-title class="justify-center font-weight-bold title pt-4">
        관리자 인증 페이지
      </v-card-title>
      <v-card-subtitle class="pt-2">
        {{ loadingMsg }}
      </v-card-subtitle>
      <v-card-text class="justify-center">
        <v-btn
          v-if="userData.uid"
          elevation="0"
          outlined
          @click="checkValid()"
        >
          {{ userData.displayName + " 계정으로 접속" }}
          <v-icon size="18"> mdi-chevron-right </v-icon>
        </v-btn>
        <v-btn v-else elevation="0" outlined @click="$router.push('login')">
          로그인
          <v-icon size="18"> mdi-chevron-right </v-icon>
        </v-btn>
      </v-card-text>
      <v-card-actions v-if="adminValid === 1" class="justify-center">
        <div>
          <span> 관리자 SMS 추가 인증 </span>
          <v-otp-input
            style="width: 240px"
            length="6"
            v-model="code.input"
            :rules="[rule.required, rule.number]"
          />
        </div>
      </v-card-actions>
    </v-card>
    <admin-appbar v-if="adminValid === 2" />
    <router-view v-if="adminValid === 2" />
  </v-container>
</template>

<script>
import AdminAppbar from "@/components/Appbar/AdminAppbar.vue";
import API from "@/API/auth.js";

export default {
  components: {
    AdminAppbar,
  },
  data() {
    return {
      userData: {},
      adminValid: 0,
      loadingMsg: "관리자 권한을 확인하고 있습니다.",
      code: { input: "", verifying: false },
      rule: {
        required: (v) => !!v || "필수 항목입니다.",
        number: (v) => /^[0-9|]+$/.test(v) || "숫자만 입력 가능합니다.",
      },
    };
  },
  async mounted() {
    try {
      await this.checkUser();
    } catch (e) {
      console.log(e);
      this.$toasted.global.error(
        "오류가 발생했습니다. 로그인 정보를 확인해주세요."
      );
      await this.checkUser();
    }
  },
  watch: {
    "code.input": {
      async handler(value) {
        if (this.code.verifying || String(value || "").length !== 6) return;

        this.code.verifying = true;
        try {
          const response = await this.$axios.patch(
            "admin/verifySecondFactor/" + this.userData.uid,
            { verificationCode: value }
          );
          this.userData.adminExpiresAt = new Date(response.data.expiresAt);
          this.adminValid = 2;
          this.$toasted.global.notice("인증이 완료되었습니다.");
        } catch (e) {
          this.$toasted.global.error("인증번호가 일치하지 않습니다.");
          this.code.input = "";
        } finally {
          this.code.verifying = false;
        }
      },
    },
  },
  methods: {
    async checkUser() {
      window.ChannelIO("shutdown");
      this.loadingMsg = "회원 정보를 조회중...";
      this.userData = await API.getStoreUserData();
      if (this.userData.uid) this.loadingMsg = "회원 로그인 확인됨";
    },
    async checkValid() {
      this.loadingMsg = "관리자 정보를 조회중...";
      if (this.userData.level >= 3) {
        this.$toasted.global.error("관리자 권한이 없습니다.");
        return this.$router.push("page");
      }

      const expiresAt =
        this.userData.adminExpiresAt instanceof Date
          ? this.userData.adminExpiresAt.getTime()
          : new Date(this.userData.adminExpiresAt || 0).getTime();

      if (Number.isFinite(expiresAt) && expiresAt > Date.now()) {
        this.adminValid = 2;
        return;
      }

      this.adminValid = 1;
      try {
        await this.$axios.patch("notice/RequestVerify", {
          uid: this.userData.uid,
          phoneNumber:
            this.userData.phoneNumberE164 || this.userData.phoneNumber,
        });
        this.code.input = "";
        this.$toasted.global.notice(
          "인증번호가 문자로 발송되었습니다."
        );
      } catch (e) {
        this.$toasted.global.error("인증번호 발송에 실패했습니다.");
        console.log(e);
      }
    },
  },
};
</script>

<style></style>
